import { createApp } from 'vue'
import './tc-claim-center.css'
import App from './App.vue'
import { flare } from "@flareapp/js";

// Only enable Flare in production, we don't want to waste your quota while you're developing:
if (process.env.NODE_ENV === 'production') {
  flare.light();
}

createApp(App).mount('#claim-center')
